import { isCCNumberValid } from './ccNumberValidation';

const ccNumWarning = (creditCardNumber, props) => {
  if (!creditCardNumber || !isCCNumberValid(creditCardNumber)) {
    return null;
  }
  const otherCards = props.currentCards || [];
  const lastFour = creditCardNumber.slice(-4);

  otherCards.some(v => {
    const currFour = (v.creditCardNumber || '').slice(-4);
    if (currFour === lastFour) {
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'duplicateCardPossibilityTrigger',
        });
      }
      return true;
    }
    return false;
  });
  return null;
};

const CreditCardInfoFormWarning = ({ creditCardNumber }, props) => ({
  ...ccNumWarning(creditCardNumber, props),
});

export default CreditCardInfoFormWarning;



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/creditCardInfoFormWarning.js